<ng-container *transloco="let t">
  <ion-header class="ion-no-border">
    <ion-toolbar>
      <ion-title>
        {{ t('About the app') }}
      </ion-title>
      <ion-buttons slot="end">
        <ion-button (click)="close()">
          <ion-icon slot="icon-only" name="close"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>

  <ion-content class="ion-padding-horizontal">
    <div style="display: flex; justify-content: space-between; align-items: center; color: var(--ion-color-dark-tint)">
      <div style="margin-top: 1px">
        <img style="height: 5.1em;" src="assets/logos/app_logo.svg">
      </div>

      <div>
        <div><b>SAFETY.app</b></div>
        <div *ngIf="version" style="margin-bottom: .5em">Version {{ version }}</div>
        <div *ngIf="author">&copy; <a href="https://www.safetyinnovation.center/" target="_blank">{{ author }}</a></div>
        <div *ngIf="license">{{ t('licensed', { license: license }) }}.</div>
      </div>

      <div>
        <img style="height: 3.1em; margin-top: -1px;" src="assets/logos/sic_logo.svg">
      </div>
    </div>

    <div #changelogOutput id="changelog-output"></div>
  </ion-content>

</ng-container>
